import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import company from "../..//assets/default/perusahaan2.png";

export default function DetailCompany({ isOpen, onClose, name, description }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Detail Perusahaan</ModalHeader>
        <ModalCloseButton />
        <hr />
        <ModalBody>
          <Box py="1">
            <Box py="2">
              <img src={company} alt="Logo" width="100%" />
            </Box>
            <Text fontWeight="500" fontSize="14px" color="#B9B9B9">
              Nama Perusahaan
            </Text>
            <Text fontWeight="500" fontSize="16px">
              {name}
            </Text>
            <Text fontWeight="500" fontSize="14px" color="#B9B9B9" pt="2">
              Deskripsi Perusahaan
            </Text>
            <Text fontWeight="400" fontSize="16px">
              {description}
            </Text>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
